import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {TranslateService} from "@ngx-translate/core";
import {RedirectRouterService} from "@shared/services/web/redirect-router.service";
import {MatDialog} from "@angular/material/dialog";
import {CredentialsService} from "@shared/services/web/credentials.service";
import { RememberToValidateModalComponent } from '../components/remember-to-validate-modal/remember-to-validate-modal.component';
import { LoginModalComponent } from '@app/security/modals/login-modal/login-modal.component';

@Injectable({
  providedIn: 'root'
})
export class UserRouteAccessGuard implements CanActivate {

  constructor(
      private router: Router,
      private credentialsService: CredentialsService,
      private readonly dialog: MatDialog,
      public redirectService: RedirectRouterService,
      private readonly translateService: TranslateService,
      @Inject(PLATFORM_ID) private platformId: Object
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const authorities = route.data['authorities'];
    return this.checkLogin(authorities, state.url);
  }

  checkLogin(authorities: string[], url: string): Observable<boolean> {
    const credentials = this.credentialsService.credentials;
    if (credentials) {
      const hasAnyAuthority =
          this.credentialsService.hasAnyAuthority(authorities);
      if (hasAnyAuthority && credentials?.verified) {
        return of(true);
      }
      this.goToPath();
      this.openRememberToValidateModal();
      return of(false);
    }
    this.router.navigate(['']).then(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.dialog.open(LoginModalComponent, {
          maxWidth: '95vw',
          panelClass: 'icon-logo-modal',
          data: { returnUrl: url },
        });
      }
    });
    return of(false);
  }

  goToPath() {
    if (
        this.router.url === '/' ||
        this.router.url === '/en' ||
        window.location.pathname.includes('/tablero')
    ) {
      this.router.navigate(['']);
    } else if (window.location.pathname.includes('/invertir')) {
      const url = this.router.url.replace('/en/', '/');
      this.redirectService.goToPage(url);
    } else if (
        this.translateService.currentLang === 'en' ||
        this.translateService.currentLang === 'es'
    ) {
      this.router.navigate([window.location.pathname]);
    }
  }

  openRememberToValidateModal() {
    this.dialog.open(RememberToValidateModalComponent, {
      position: { top: 'true' },
      panelClass: 'panel-flow-save-search',
      maxWidth: '485px',
    });
  }

}
